<template>
  <Label
    v-if="showLabel"
    :color="discipline.meta.color"
    :label="$t('disciplines.' + discipline.attributes.name)"
  />
</template>

<script>
import { Query, Resource, Type } from '@/src/server/helpers/constants'
import Label from '@/src/server/components/shared/Label'

export default {
  components: {
    Label,
  },

  props: {
    discipline: {
      type: Object,
      required: true,
      validator (value) {
        return value.type === Type.DISCIPLINE
      },
    },
  },

  computed: {
    showLabel () {
      return this.$route.query.labels === undefined ||
        this.$route.query.labels === Query.TRUE ||
        (this.$route.query.labels || '').split(',').includes(Resource.DISCIPLINE)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/server/components/shared/DisciplineLabel.vue